module.exports = {"content":{},"productInfo":{"code":"{6393F594-264D-4C55-8FF0-0E9DB5C19319}","name":"オランダ語　初中級","serialHead":"ZTGXM","courseResourceIDs":[{"levelNo":1,"resourceID":"4058222cd3bab7d279b53d9279aae8bdb1b1bb9e"},{"levelNo":2,"resourceID":"f3fdb156f512f718ee220d7245aff01963694ee2"},{"levelNo":3,"resourceID":"3115504aa0438b932258d5b24cb8d10866edb04d"}],"language":"nl-NL","challengeCount":21679},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1